<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper" v-if="viewType == 'show'">
      <a-form @keyup.enter.native="getList" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <a-form-item label="巡检结果">
              <j-multi-select-tag
                @change="getList"
                dictCode="patrol_record_result"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.recordResList"
              ></j-multi-select-tag>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <a-form-item label="复核状态">
              <j-multi-select-tag
                @change="getList"
                dictCode="patrol_record_review_status"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.reviewStatusList"
              ></j-multi-select-tag>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <a-form-item label="巡检时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="getList"
                format="YYYY-MM-DD"
                v-model="timeRange"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="getList" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="viewType == 'show'">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <a-button @click="handleExportXls('智能巡检记录')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div v-if="viewType == 'show'">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>
    </div>
    <a-table
      :columns="columns"
      :customRow="customRowRender"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="ipagination"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :scroll="{ x: true }"
      @change="handleTableChange"
      bordered
      class="j-table-force-nowrap"
      ref="table"
      rowKey="id"
      size="middle"
    >
      <span slot="recordRes" slot-scope="priority, record">
        <!-- <span v-if="record.recordRes=='1'">
                    <a-tag color="#52c41a">{{record.recordRes_dictText}}</a-tag>
                </span>
                <span v-else-if="record.recordRes=='2'">
                    <a-tag color="#ff4d4f">{{record.recordRes_dictText}}</a-tag>
        </span>-->
        <!-- patrol_result_color -->
        <a-tag :color="$filterDictTextByCache('patrol_result_color', record.recordRes)">{{
          record.recordRes_dictText
        }}</a-tag>
      </span>
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="imgSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
        <img
          :src="getImgView(text)"
          alt
          height="25px"
          style="max-width:80px;font-size: 12px;font-style: italic;"
          v-else
        />
      </template>
      <template slot="fileSlot" slot-scope="text">
        <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
        <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
          >下载</a-button
        >
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleViewPatrolReport(record)">查看巡检报告</a>
        <a-divider type="vertical" />
        <a @click="handleManualReview(record)">人工复核</a>
        <!-- <a-divider type="vertical" />
        <a @click="handlePatrolRoute(record)">巡检路线</a>-->
        <a-divider type="vertical" />
        <a @click="handleAlarmInformation(record)">告警信息</a>
      </span>
    </a-table>

    <yw-intelligent-patrol-record-modal @ok="modalFormOk" ref="modalForm"></yw-intelligent-patrol-record-modal>
    <yw-intelligent-patrol-report-modal @ok="modalFormOk" ref="reportForm"></yw-intelligent-patrol-report-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import YwIntelligentPatrolRecordModal from './modules/YwIntelligentPatrolRecordModal'
import YwIntelligentPatrolReportModal from './modules/YwIntelligentPatrolReportModal'
import { validatenull, validatenotnull } from '@/utils/validate'

export default {
  name: 'YwIntelligentPatrolRecordList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    YwIntelligentPatrolRecordModal,
    YwIntelligentPatrolReportModal
  },
  props: {
    viewType: {
      type: String,
      default: 'show'
    }
  },
  data() {
    return {
      description: '智能巡检记录管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '计划',
          align: 'center',
          dataIndex: 'planId_dictText'
        },
        {
          title: '复核状态',
          align: 'center',
          dataIndex: 'reviewStatus_dictText',
          sorter: true
        },
        {
          title: '复核人',
          align: 'center',
          dataIndex: 'reviewPerson_dictText'
        },
        {
          title: '巡检结果',
          align: 'center',
          dataIndex: 'recordRes_dictText',
          scopedSlots: {
            customRender: 'recordRes'
          },
          sorter: true
        },
        {
          title: '巡检时间',
          align: 'center',
          dataIndex: 'recordTime',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 250,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/maintenance/ywIntelligentPatrolRecord/list',
        delete: '/maintenance/ywIntelligentPatrolRecord/delete',
        deleteBatch: '/maintenance/ywIntelligentPatrolRecord/deleteBatch',
        exportXlsUrl: '/maintenance/ywIntelligentPatrolRecord/exportXls',
        importExcelUrl: 'maintenance/ywIntelligentPatrolRecord/importExcel'
      },
      dictOptions: {},
      superFieldList: [],
      timeRange: [],
      isorter: {
        column: 'recordRes',
        order: 'desc'
      }
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    getList() {
      if (validatenull(this.timeRange)) {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      } else {
        this.queryParam.startTime = this.timeRange[0] + ' 00:00:00'
        this.queryParam.endTime = this.timeRange[1] + ' 23:59:59'
      }
      console.log(this.queryParam)
      this.searchQuery()
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({
        type: 'string',
        value: 'reviewStatus',
        text: '复核状态',
        dictCode: 'patrol_record_review_status'
      })
      fieldList.push({ type: 'string', value: 'reviewPerson', text: '复核人', dictCode: '' })
      fieldList.push({ type: 'string', value: 'recordRes', text: '巡检结果', dictCode: 'patrol_record_result' })
      fieldList.push({ type: 'date', value: 'recordTime', text: '巡检时间' })
      this.superFieldList = fieldList
    },
    //查看巡检报告
    handleViewPatrolReport: function(record) {
      this.$refs.reportForm.edit(record)
      this.$refs.reportForm.title = '巡检报告'
      this.$refs.reportForm.disableSubmit = true
    },
    //人工复核
    handleManualReview: function(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '人工复核'
      this.$refs.modalForm.disableSubmit = false
    },
    //巡检路线
    handlePatrolRoute: function(record) {
      this.$message.warning('暂未开放')
    },
    //告警信息
    handleAlarmInformation: function(record) {
      this.$router.push({ path: '/alert/center' })
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
